import { useEffect } from 'react';
import Button from '../../components/ui/Button';
import Trophy from '../../assets/images/Percentage.png';
import goal from '../../assets/images/Gold-Pot.png';
import Ticket from '../../assets/icons/ticket.svg';
import { useNavigate } from 'react-router-dom';
import { User } from 'lucide-react';
import TransactionTicketPopup from '../../components/Popup/TransactionTicketPopup ';
import { useState } from 'react';
import { getGameImage } from '../../utils/getGameImage';
import getGameType from '../../utils/games';

import { gamesApi } from '../../api/games';
import { useAuth } from '../../context/AuthContext';
export default function CommissionCard({
  game,
  logo: Logo,
  drawTime,
  drawDate,
  owner,
  source,
  amount,
  commission,
  user,
  ticketId,
  onTicketLoading,
  transactionReciept,
  isGrouped,
  // showTicketInfo,
  isLastItem,
  totalAmountz,
  gameData
}) {
  const navigate = useNavigate();
  const { tokens } = useAuth();
  const [ticketPopup, setTicketPopup] = useState(false);
  const [gameSettings, setGameSettings] = useState(null);
  const [gameSettingsLogo, setGameSettingsLogo] = useState(null);

  const handleTicketPopup = () => {
    setTicketPopup(true);
  };

  const fetchGameSettings = async () => {
    const response = await gamesApi.getAllGames(tokens.access.token);
    setGameSettings(response.data);
  };

  useEffect(() => {
    fetchGameSettings();
  }, []);
  
  useEffect(() => {
    if (transactionReciept && transactionReciept.game.game_settings.other_settings) {
      const imageType = getGameType(transactionReciept.game.game_settings.other_settings.image);
      const gameImage = getGameImage(imageType);
      setGameSettingsLogo(gameImage);
    }
  }, [gameData, gameSettings]);

  return (
    <>
      <div
        className={`bg-white rounded-md border ${
          isGrouped ? 'mb-1' : 'mt-2.5 '
        }`}
      >
        <div className='flex items-start gap-2.5 p-2.5 '>
          {gameSettingsLogo ? (
            <img src={gameSettingsLogo} width={62} height={62} className='rounded-lg' />
          ) : Logo ? (
            <img src={Logo} width={62} height={62} className='rounded-lg' />
          ) : (
            <div className='w-[62px] h-[62px] rounded-lg bg-gray-200 flex items-center justify-center'>
              <span className='text-gray-600 font-bold'>
                {game?.substring(0, 2) || '?'}
              </span>
            </div>
          )}
          <div className='flex-1'>
            <div className='flex items-center justify-between'>
              <h3 className='font-bold text-base'>{game}</h3>
              <Button
                className='bg-[#0E64D1] text-white text-xs px-2 p-1.5 rounded-[4px]'
                text='View Ticket'
                onClick={handleTicketPopup}
              />
            </div>

            <div className='grid grid-cols-2 mt-2'>
              <div>
                <div className='text-[10px] text-gray-600'>Draw Time</div>
                <div className='font-semibold text-xs'>{drawTime}</div>
              </div>
              <div>
                <div className='text-[10px] text-gray-600'>Draw Date</div>
                <div className='font-semibold text-xs'>{drawDate}</div>
              </div>
            </div>

            <div className='grid grid-cols-2  mt-2'>
              <div>
                <div className='text-[10px] text-gray-600'>Owner</div>
                <div className='font-semibold text-xs'>{owner}</div>
              </div>
              <div>
                <div className='text-[10px] text-gray-600'>Source</div>
                <div className='font-semibold text-xs'>{source}</div>
              </div>
            </div>

            <div className='grid grid-cols-2 gap-4 mt-2'>
              <div
                className=' rounded-lg  flex justify-between'
                style={{
                  background:
                    'linear-gradient(180deg, #65758B 0%, #12131A 100%)',
                }}
              >
                <div className='text-white p-2.5 self-center'>
                  <div className='text-xs font-normal'>Amount</div>
                  <div className='font-semibold text-xl '>₱{totalAmountz}</div>
                </div>
                <div className='self-end'>
                  <img src={goal} alt='Total Hits' width={42} height={42} />
                </div>
              </div>
              <div
                className=' rounded-lg  flex justify-between'
                style={{
                  background:
                    'linear-gradient(180deg, #9B00FF 0%, #7D00CE 100%)',
                }}
              >
                <div className='text-white p-2.5 self-center'>
                  <div className='text-xs font-normal'>Commission</div>
                  <div className='font-bold text-xl'>₱{commission}</div>
                </div>
                <div className='self-end relative'>
                  <img src={Trophy} alt='Total Win' width={62} height={62} />
                </div>
              </div>
            </div>
          </div>
        </div>

        {(!isGrouped || isLastItem) && (
          <>
            <div className='flex items-center gap-2 px-2 pt-1 text-[#65758B] text-[10px] bg-[#E1E7EF] font-normal border-t border-dashed border-[#65758B] '>
              <User className='h-3.5 w-3.5' />
              User : {transactionReciept.User.name}
            </div>

            <div className=' flex items-center gap-2 px-2 pb-1 text-[#65758B] text-[10px] bg-[#E1E7EF] font-normal'>
              <img
                src={Ticket}
                alt={game}
                width={14}
                height={14}
                className='rounded-lg'
              />
              Ticket : {ticketId}
            </div>
          </>
        )}
      </div>

      <TransactionTicketPopup
        isOpen={ticketPopup}
        ticketId={ticketId}
        onClose={() => setTicketPopup(false)}
        onLoading={onTicketLoading}
      />
    </>
  );
}
